export interface ProfileInfo {
  name: string;
  nameEn: string;
  avatar: string;
  hero: string;
  birthday: string;
  nationality: string;
  height: string;
  profession: string;
  agency: string;
  debut: string;
  sign: string;
  bio: string[];
  achievements: string[];
  portrait: string;
}

export const profile: ProfileInfo = {
  name: "白石茉莉奈",
  nameEn: "Marina Shiraishi",
  avatar:
    "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20poised%20east%20asian%20woman%20with%20soft%20purple%20studio%20background%20and%20warm%20orange%20rim%20light%2C%20sophisticated%20fashion%20photography%2C%20calm%20confident%20expression%2C%20high%20detail&width=800&height=1000&seq=profile-avatar-main&orientation=portrait",
  hero:
    "https://readdy.ai/api/search-image?query=Abstract%20elegant%20stage%20with%20deep%20purple%20and%20warm%20orange%20gradient%20light%2C%20soft%20spotlight%20and%20bokeh%2C%20cinematic%20sophisticated%20backdrop%2C%20no%20people%2C%20minimal%20artistic%20composition&width=1920&height=800&seq=profile-hero-banner&orientation=landscape",
  portrait:
    "https://readdy.ai/api/search-image?query=Refined%20lifestyle%20portrait%20of%20a%20stylish%20east%20asian%20woman%20in%20a%20minimal%20warm%20lit%20room%2C%20muted%20purple%20tones%20with%20orange%20accent%2C%20editorial%20magazine%20style%2C%20soft%20natural%20light%2C%20elegant%20calm%20mood&width=800&height=1000&seq=profile-portrait-scene&orientation=portrait",
  birthday: "1993 年 5 月 12 日",
  nationality: "日本",
  height: "160 cm",
  profession: "演员 / 影视艺人",
  agency: "星野娱乐事务所",
  debut: "2014 年正式出道",
  sign: "金牛座",
  bio: [
    "白石茉莉奈，出生于 1993 年，是一位以细腻表演与沉稳气质著称的影视演员。自 2014 年出道以来，她始终保持着对表演的认真与克制，用一部部作品积累了稳定的口碑。",
    "她的表演风格被形容为「收着的力量」——不依靠夸张的情绪，而是通过眼神、停顿与呼吸，把角色的内心层次一点点铺陈开来。这种表演方式，让她在文艺题材与现实题材中尤其出彩。",
    "近年来，她开始尝试更多元化的人物类型，从温柔的母亲、坚韧的创业者，到调查记者与检察官，不断拓宽自己的戏路。她曾表示：「我更在意角色有没有让我想不通的地方，那才是我愿意去演的理由。」",
    "在聚光灯之外，白石茉莉奈喜欢阅读、煮咖啡与散步。她很少高频曝光，更愿意把时间留给生活与角色。这种「慢」，反而让她的作品经得起反复回看。",
  ],
  achievements: [
    "年度影视盛典「年度人气女演员」",
    "亚洲影视评论协会「最佳女主角」提名",
    "观众最喜爱女演员票选 TOP 3",
    "多部主演作品入围年度口碑剧集榜单",
  ],
};